import {Component, OnInit, Inject} from '@angular/core';
import {ErrorStateMatcher, DateAdapter, MAT_DATE_LOCALE} from '@angular/material/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {FormControl, FormGroupDirective, NgForm} from '@angular/forms';
import {ConfirmComponent} from 'src/app/shared/dialogs/confirm/confirm.component';
import {InviteSpeakersService} from 'src/app/services/invite-speakers.service';

/** Error when invalid control is dirty, touched, or submitted. */
export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-invite-speakers-dialog',
  templateUrl: './invite-speakers-dialog.component.html',
  styleUrls: ['./invite-speakers-dialog.component.scss'],
  entryComponents: [
    ConfirmComponent
  ],
  providers: [
    {provide: MAT_DATE_LOCALE, useValue: 'pt-BR'}
  ]
})
export class InviteSpeakersDialogComponent implements OnInit {

  //public currentAgenda: any = {}
  public letter: any;
  public invite: any;

  constructor (
    public _inviteSpeakersService: InviteSpeakersService,
    private _adapter: DateAdapter<any>,
    public matDialogRef: MatDialogRef<InviteSpeakersDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    //console.log(JSON.stringify(this.data))
    this.letter = this.data.letter;
    this.invite = this.data.invite; 
    //console.log(JSON.stringify(this.invite))
   }

  ngOnInit () {
    this._adapter.setLocale('pt');  
  }

}
